import moment from "moment";

export class WorkService {
  constructor (API, Auth, ItCache) {
    'ngInject';

    this.API = API;
    this.Auth = Auth;
    this.ItCache = ItCache;
  }

  getWorkspace(allProjects) {
    return this.ItCache.get("workspace", () => {
      return this.Auth.httpWithAuthToken({
        method: 'GET',
        url: this.API.root + '/workspace',
        params: { allProjects }
      });
    }, 60 * 60 * 1000);
  }

  getClientsWithFlagsHistory() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/projects/history'
    });
  }

  getTimeNow(correlationId) {
    const headers = (correlationId && {"Correlation-Id": correlationId}) || undefined;
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/time/now',
      headers: headers,
      params: {
        cacheBuster: Math.random().toString().slice(2,10)
      }
    }).then((result) => {
      return moment.parseZone(result.data.now, ["YYYY-MM-DDTHH:mm:ss.SSSZ", "YYYY-MM-DDTHH:mm:ssZ"]);
    }, () => {
      return moment();
    });
  }

  processIsLongEnoughToAskIfWeWantToContinue() {
    if (localStorage.getItem("roedl-time-started")){
      var startTime = moment(angular.fromJson(localStorage.getItem("roedl-time-started")));
      var timeNow = moment();
      var minutesPassed = moment.duration(timeNow.diff(startTime)).asMinutes();
      return (minutesPassed > 5);
    } else {
      return false;
    }
  }

  processIsLostAskIfWeWantToContinue() {
    if (localStorage.getItem("roedl-time-started")){
      // var startTime = moment(angular.fromJson(localStorage.getItem("roedl-time-started")));
      // var timeNow = moment();
      // var minutesPassed = moment.duration(timeNow.diff(startTime)).asMinutes();
      //return (minutesPassed > 5);

      return true;
    } else {
      return false;
    }
  }

  processIsOverdue(startTime) {
    var timeNow = moment();
    var dateChanged = startTime.format("YYYY-MM-DD") != timeNow.format("YYYY-MM-DD");
    return dateChanged;
  }

  isBookmarked(searchTerm) {
    var localStorageValues = angular.fromJson(localStorage.getItem("ngStorage-roedl-session"));
    var bookmarks = null;
    if (localStorageValues.preferences && localStorageValues.preferences.bookmarks)
      bookmarks = localStorageValues.preferences.bookmarks;
    else
      bookmarks = [];
    return bookmarks.some(({uuid}) => uuid == searchTerm);
  }

  unbookmark(unbookmarkedUuid) {
    return this.Auth.getPreferences().then((preferences) => {
      var newPreferences = angular.copy(preferences);
      var bookmarks = preferences.bookmarks || [];
      newPreferences.bookmarks = bookmarks.filter(({uuid}) => uuid != unbookmarkedUuid);
      return this.Auth.patchPreferences(newPreferences);
    });
  }

  bookmark(uuid, type) {
    return this.Auth.getPreferences().then((preferences) => {
      var newPreferences = angular.copy(preferences);
      var bookmarks = preferences.bookmarks || [];
      var newBookmark = {uuid, type};
      newPreferences.bookmarks = bookmarks.concat([newBookmark]);
      return this.Auth.patchPreferences(newPreferences);
    });
  }

  log(worklog, correlationId) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/worklog',
      headers: {
        "Correlation-Id": correlationId
      },
      data: worklog
    });
  }

  logWithApplication(worklog, correlationId) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/worklog/overtime-application',
      headers: {
        "Correlation-Id": correlationId
      },
      data: worklog
    });
  }

  fireAndForgetMetric(originalData, correlationId) {
    var newTabControl = "time-start-"+sessionStorage.getItem("start-time")+"-location-start-"+sessionStorage.getItem("start-location")+"-reload-"+sessionStorage.getItem("reload-time");
    var data = angular.copy(originalData);
    data.newTabControl = newTabControl;
    data.version = window.frontendVersion;
    var headers = {};
    if(correlationId) {
      headers["Correlation-Id"] = correlationId;
    }
    return this.Auth.httpWithAuthTokenWithoutRefreshing({
      method: 'POST',
      url: this.API.root + '/metrics',
      headers: headers,
      data: data
    });
  }

  reportStateChange(newState, user, correlationId) {
    var previousTimeString = localStorage.getItem("roedl-state-change-time");
    var previousState = localStorage.getItem("roedl-state-change-state");
    var previousPreviousState = localStorage.getItem("roedl-state-change-state-previous");
    var previousTime = previousTimeString && moment(previousTimeString);
    var newTime = moment();
    var nowTimeString = newTime.toISOString();
    var duration = previousTime && moment.duration(newTime.diff(previousTime)).asMilliseconds();
    var userAgent = navigator.userAgent;
    var userEmail = user && user.emailAddress;

    var timezone = moment.tz.guess();
    var url = location.pathname;
    var newTabControl = "time-start-"+sessionStorage.getItem("start-time")+"-location-start-"+sessionStorage.getItem("start-location")+"-reload-"+sessionStorage.getItem("reload-time");
    const data = {
      type: "METRIC_STATE",
      newState,
      nowTimeString,
      previousState,
      previousPreviousState,
      previousTimeString,
      duration,
      userAgent,
      userEmail,
      timezone,
      url,
      version: window.frontendVersion,
      newTabControl
    };
    /// UPDATING STATE
    localStorage.setItem("roedl-state-change-time", nowTimeString);
    localStorage.setItem("roedl-state-change-state", newState);
    localStorage.setItem("roedl-state-change-state-previous", previousState);

    this.Auth.httpWithAuthTokenWithoutRefreshing({
      method: 'POST',
      url: this.API.root + '/metrics',
      headers: {
        "Correlation-Id": correlationId
      },
      data: data
    }).then(angular.noop,angular.noop);
  }

  removeAnyTraceOfTheSavedProcess() {
    this.removeItemsFromLocalStorage("pg", "interruption", "clientId");
  }

  removeItemsFromLocalStorage(pg,interruption,clientId) {
    localStorage.removeItem("roedl-time-started");
    localStorage.removeItem("roedl-worklog-id");
    localStorage.removeItem("roedl-time-duration-interruption");
    if(pg == "pg")
      localStorage.removeItem("roedl-time-started-pg");
    if(interruption == "interruption") {
      localStorage.removeItem("roedl-time-started-interruption");
      localStorage.removeItem("roedl-interruption-id");
    }
    if(clientId == "clientId")
      localStorage.removeItem("roedl-time-started-client-id");
  }

  getDailyStats() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/daily-stats'
    });
  }

  // If there is only process ID in Data it will hide process for all the clients.
  // If there is also a client ID, this process will be hidden only for this client.
  hideProcess(data) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/hidden-processes',
      data
    });
  }

  uncoverProcessForAllClients(processId) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + '/hidden-processes/' + processId
    });
  }

  uncoverProcessForClient(processId, clientId) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + '/hidden-processes/' + processId +'/client/' + clientId
    });
  }

  getJobCodeMappers() {
    return this.Auth.httpWithAuthToken({
      url: this.API.root + '/workspace/mappers'
    });
  }

  getProjectsJobCodeMappers() {
    return this.Auth.httpWithAuthToken({
      url: this.API.root + '/workspace/mappers/projects'
    });
  }

  getViewLevelSettings() {
    return this.Auth.httpWithAuthToken({
      url: this.API.root + '/management/settings/view-level'
    });
  }

  editViewLevelSettings(data) {
    return this.Auth.httpWithAuthToken({
      method: 'PUT',
      url: this.API.root + '/management/settings/view-level',
      data
    });
  }

  getClientsWithFlagsHistoryForManager() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/country/projects/history'
    });
  }

  getNoteLatestVersion(params) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + `/note/${params.processId ? 'process-' : ''}client`,
      params: params
    });
  }

  postHearbeat(data) {
    return this.Auth.httpWithAuthToken({
      method: 'PUT',
      url: this.API.root + `/note/${data.processId ? 'process-' : ''}client/heartbeat`,
      data: data
    });
  }

  getHeartbeat(params) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + `/note/${params.processId ? 'process-' : ''}client/heartbeat/status`,
      params: params
    });
  }

  saveNote(data) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + `/note/${data.processId ? 'process-' : ''}client`,
      data: data
    });
  }

  getNoteHistory(params) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + `/note/${params.processId ? 'process-' : ''}client/history`,
      params: params
    });
  }

  clearHeartbeat(params) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + `/note/${params.processId ? 'process-' : ''}client/heartbeat`,
      params: params
    });
  }

  getAutomationTechnologyForCountry() {
    return this.Auth.httpWithAuthToken({
      url: this.API.root + '/country/automation'
    });
  }

  getClientsAutomationTechnology(params) {
    return this.Auth.httpWithAuthToken({
      url: this.API.root + '/automation/process-client',
      params
    });
  }

  saveClientsAutomationTechnologies(data) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/automation/process-client',
      data
    });
  }

  getCountryBillingTypes() {
    return this.Auth.httpWithAuthToken({
      url: this.API.root + `/country/billing-type`
    });
  }

  getInterruptsDuringProcess(data) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + "/worklog/interrupts",
      data
    });
  }

  getNotesInfoForClientsAndProcesses(updateCache) {
    if (updateCache)
      this.ItCache.clearSpecific("notesInfoForClientsAndProcesses");

    return this.ItCache.get("notesInfoForClientsAndProcesses", () => {
      return this.Auth.httpWithAuthToken({
        url: this.API.root + "/note/clients-and-processes"
      });
    }, 10 * 60 * 1000);
  }
}
